import { useEffect } from 'react'

import ChatService from 'modules/chat/service'
import { useChatContext } from '../context'
import { useTransmissionContext } from 'modules/transmission/context'

const useChatViewers = () => {
  const { transmissionData: { code } } = useTransmissionContext()
  const { setViewers, isLoaded } = useChatContext()

  useEffect(() => {
    const onlineCounterUpdate = (viewers?: number) => setViewers(viewers || 0)

    code && isLoaded && ChatService.subscribeEvents({
      onlineCounterUpdate
    })

    return () => {
      code && isLoaded && ChatService.removeEventSubscription({
        onlineCounterUpdate
      })
    }
  }, [code, isLoaded, setViewers])
}

export default useChatViewers
